/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CreatePromoCodeRequest
 */
export interface CreatePromoCodeRequest {
  /**
   * Дата начала действия промокода (формат Y-m-d H:i:s)
   * @type {Date}
   * @memberof CreatePromoCodeRequest
   */
  startAt: Date
  /**
   * Дата окончания действия промокода (формат Y-m-d H:i:s)
   * @type {Date}
   * @memberof CreatePromoCodeRequest
   */
  expireAt: Date
  /**
   * Количество использований; по умолчанию 1
   * @type {number}
   * @memberof CreatePromoCodeRequest
   */
  number?: number
  /**
   * Код промокода; генерируется автоматически, если не передан
   * @type {string}
   * @memberof CreatePromoCodeRequest
   */
  code?: string
}

/**
 * Check if a given object implements the CreatePromoCodeRequest interface.
 */
export function instanceOfCreatePromoCodeRequest(
  value: object
): value is CreatePromoCodeRequest {
  if (!('startAt' in value) || value['startAt'] === undefined) return false
  if (!('expireAt' in value) || value['expireAt'] === undefined) return false
  return true
}

export function CreatePromoCodeRequestFromJSON(
  json: any
): CreatePromoCodeRequest {
  return CreatePromoCodeRequestFromJSONTyped(json, false)
}

export function CreatePromoCodeRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreatePromoCodeRequest {
  if (json == null) {
    return json
  }
  return {
    startAt: new Date(json['startAt']),
    expireAt: new Date(json['expireAt']),
    number: json['number'] == null ? undefined : json['number'],
    code: json['code'] == null ? undefined : json['code'],
  }
}

export function CreatePromoCodeRequestToJSON(
  value?: CreatePromoCodeRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    startAt: value['startAt'].toISOString(),
    expireAt: value['expireAt'].toISOString(),
    number: value['number'],
    code: value['code'],
  }
}
